export default function Ask() {
  return (
    <>
<section className="dark" id="s-ask"><span id="privacy"></span>
  <div className="dark-glow"></div>
  <div className="dark-inner container">
    <div className="ask-brand">
      <img src="/assets/mark-teamgrid.svg" style={{width: '34px', height: '34px'}} alt="" />
      <span className="askword">Ask TeamGrid</span>
    </div>
    <h2>The answers are already<br /><em>inside</em> your company</h2>
    <p className="dsub">Plugged into your teams, your tools, and the way your company actually works.</p>
    <div className="avail">
      <span className="al">ONE LIGHTWEIGHT AGENT</span>
      <span className="plat">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16.36 12.78c-.02-2.3 1.88-3.4 1.96-3.46-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.48.83-.72 0-1.83-.81-3.01-.79-1.55.02-2.98.9-3.78 2.28-1.61 2.8-.41 6.94 1.16 9.21.77 1.11 1.68 2.36 2.87 2.31 1.15-.05 1.59-.74 2.98-.74 1.39 0 1.78.74 3 .72 1.24-.02 2.02-1.13 2.78-2.24.88-1.29 1.24-2.54 1.26-2.6-.03-.01-2.41-.93-2.42-3.72zM14.09 5.4c.63-.77 1.06-1.83.94-2.9-.91.04-2.02.61-2.67 1.37-.58.68-1.09 1.77-.95 2.81 1.02.08 2.05-.52 2.68-1.28z" /></svg>
        macOS
      </span>
      <span className="plat">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5.1 10.4 4v7.4H3zm8.6-1.3L21 2.4v9H11.6zM3 12.6h7.4V20L3 18.9zm8.6 0H21v9l-9.4-1.3z" /></svg>
        Windows
      </span>
      <span className="plat">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2c-2.05 0-3.35 1.55-3.28 3.6.05 1.35-.15 2.05-.72 2.9-.62.92-1.28 1.9-1.72 3.1-.32.88-.6 1.62-1 2.2-.5.72-.32 1.55.4 1.78.55.18 1.15.05 1.6-.25.28.75.7 1.35 1.3 1.78-.35.5-.6 1.05-.6 1.6 0 .5.4.9.9.9h6.24c.5 0 .9-.4.9-.9 0-.55-.25-1.1-.6-1.6.6-.43 1.02-1.03 1.3-1.78.45.3 1.05.43 1.6.25.72-.23.9-1.06.4-1.78-.4-.58-.68-1.32-1-2.2-.44-1.2-1.1-2.18-1.72-3.1-.57-.85-.77-1.55-.72-2.9.07-2.05-1.23-3.6-3.28-3.6z" /></svg>
        Linux
      </span>
    </div>
    <p className="avail-sub">Intel &amp; Apple Silicon · .deb &amp; AppImage · installs in 5 minutes{' '}·{' '}<a href="/download/all">See all downloads →</a></p>

    <div className="pillars">
      <div className="pillar">
        <div className="pl">CONTEXT</div>
        <p>Ask TeamGrid sees activity, attendance, and comms health in real time. <b>It never needs a status update</b> — it already knows what happened today.</p>
        <div className="pv">
          <div className="kv"><span className="k">signal</span><span>after-hours work · 3× baseline · Marketing</span></div>
          <div className="kv"><span className="k">since</span><span>Tue, 11:40 AM — unprompted</span></div>
        </div>
      </div>
      <div className="pillar">
        <div className="pl">INTELLIGENCE</div>
        <p><b>The right model for every question.</b> One subscription; every frontier model reads your org's full context before it answers.</p>
        <div className="modelrow">
          <span className="modelchip">✦ Pattern AI</span>
          <span className="modelchip">GPT</span>
          <span className="modelchip">Claude</span>
          <span className="modelchip">Gemini</span>
        </div>
      </div>
      <div className="pillar">
        <div className="pl">PRIVACY</div>
        <p><b>Patterns, not people.</b> No screenshots. No keystrokes. No camera. TeamGrid reads the shape of work — never the private content of it.</p>
        <div className="pv">
          <div className="kv"><span className="k">screenshots</span><span>never captured</span></div>
          <div className="kv"><span className="k">keystrokes</span><span>never logged</span></div>
          <div className="kv"><span className="k">email</span><span>metadata only</span></div>
        </div>
      </div>
    </div>
  </div>

  <div className="whatsnew">
    <h3 className="wn-h">Nothing else sees <span className="dim">the whole org</span></h3>
    <div className="wn-grid">
      <div className="wn-card"><div className="wl">ORG MEMORY</div><p>TeamGrid remembers how your company works — and gets sharper with every week of signal.</p><div className="demo-line"><span className="gtag">LEARNED</span>Design does deep work before noon</div></div>
      <div className="wn-card"><div className="wl">ANOMALY FEED</div><p>Every-7th-day leave patterns, reply-lag spikes, silent overtime — surfaced the day they start.</p><div className="demo-line"><span className="gtag">FLAGGED</span>Leave requests: every 7th working day</div></div>
      <div className="wn-card"><div className="wl">FOUNDER'S REPORT</div><p>Monday, 9:00 AM: the whole company in one brief — wins, risks, and the week ahead.</p><div className="demo-line"><span className="gtag">SENT</span>Weekly brief · 3 risks · 5 wins</div></div>
      <div className="wn-card"><div className="wl">CONNECTED APPS</div><p>Gmail metadata, calendars, project tools, browsers — every signal joins one timeline.</p><div className="demo-line"><span className="gtag">SYNCED</span>14 sources · streaming now</div></div>
      <div className="wn-card"><div className="wl">MULTIPLAYER INSIGHT</div><p>The more teams on TeamGrid, the smarter it gets for everyone — from intern to founder.</p><div className="demo-line"><span className="gtag">TEAMS</span>Engineering · Sales · Support · Design</div></div>
      <div className="wn-card"><div className="wl">DEEP SEARCH</div><p>Ask something hard. TeamGrid checks activity, email lag, attendance, and the org graph.</p><div className="demo-line"><span className="gtag">ASKED</span>"Why did support slow down in May?"</div></div>
    </div>
    <div className="dark-cta">
      <a className="btn-white" href="/register">Get started with Ask TeamGrid</a>
      <a className="btn-outline-dark" href="/pattern-intelligence">Learn more</a>
    </div>
  </div>
</section>
    </>
  );
}
